import { render, staticRenderFns } from "./AuditReportPanel.vue?vue&type=template&id=564d04ca&scoped=true"
import script from "./AuditReportPanel.vue?vue&type=script&lang=js"
export * from "./AuditReportPanel.vue?vue&type=script&lang=js"
import style0 from "./AuditReportPanel.vue?vue&type=style&index=0&id=564d04ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564d04ca",
  null
  
)

export default component.exports